import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminComponent } from '../admin/admin.component';
import { AccAccountComponent } from './acc-account/acc-account.component';
import { BankPaymentComponent } from './bank-payment/bank-payment.component';
import { BankReceiptComponent } from './bank-receipt/bank-receipt.component';
import { CashReceiptComponent } from './cash-receipt/cash-receipt.component';
import { CashPaymentComponent } from './cash-payment/cash-payment.component';
import { BankPaymentPrintComponent } from './bank-payment-print/bank-payment-print.component';
import { BankPaymentVoucherPrintComponent } from './bank-payment-voucher-print/bank-payment-voucher-print.component';
import { BankReceiptPrintComponent } from './bank-receipt-print/bank-receipt-print.component';
import { BankReceiptVoucherPrintComponent } from './bank-receipt-voucher-print/bank-receipt-voucher-print.component';
import { CashPaymentVoucherPrintComponent } from './cash-payment-voucher-print/cash-payment-voucher-print.component';
import { CashPaymentPrintComponent } from './cash-payment-print/cash-payment-print.component';
import { CashReceiptPrintComponent } from './cash-receipt-print/cash-receipt-print.component';
import { CashReceiptVoucherPrintComponent } from './cash-receipt-voucher-print/cash-receipt-voucher-print.component';
import { JournalComponent } from './journal/journal.component';
import { JournalReportComponent } from './journal-report/journal-report.component';
import { BalancesheetReportComponent } from './balancesheet-report/balancesheet-report.component';
import { TrialbalanceReportComponent } from './trialbalance-report/trialbalance-report.component';
import { ProfitLossReportComponent } from './profit-loss-report/profit-loss-report.component';
import { VoucherReportComponent } from './voucher-report/voucher-report.component';
import { VoucherReportPrintComponent } from './voucher-report-print/voucher-report-print.component';
import { JournalVoucherPrintComponent } from './journal-voucher-print/journal-voucher-print.component';
import { ProfitLossReportPrintComponent } from './profit-loss-report-print/profit-loss-report-print.component';
import { TrialbalanceReportPrintComponent } from './trialbalance-report-print/trialbalance-report-print.component';
import { BalancesheetReportPrintComponent } from './balancesheet-report-print/balancesheet-report-print.component';
import { JournalReportPrintComponent } from './journal-report-print/journal-report-print.component';
import { LedgerComponent } from './ledger/ledger.component';
import { LedgerPrintComponent } from './ledger-print/ledger-print.component';
import { BankComponent } from './bank/bank.component';
import { BankAccountComponent } from './bank-account/bank-account.component';
import { VendorComponent } from './vendor/vendor.component';
import { FeeDailyClosingComponent } from './fee-daily-closing/fee-daily-closing.component';
import { PostFeeDailyComponent } from './post-fee-daily/post-fee-daily.component';
import { PostModernExchangeFeeDailyComponent } from './post-modern-exchange-fee-daily/post-modern-exchange-fee-daily.component';
import { AccSettingComponent } from './acc-setting/acc-setting.component';
import { VoucherPaymentComponent } from './voucher-payment/voucher-payment.component';
import { VoucherReceiptComponent } from './voucher-receipt/voucher-receipt.component';
import { VoucherPaymentPrintComponent } from './voucher-payment-print/voucher-payment-print.component';
import { VoucherPaymentListPrintComponent } from './voucher-payment-list-print/voucher-payment-list-print.component';
import { VoucherReceiptPrintComponent } from './voucher-receipt-print/voucher-receipt-print.component';
import { VoucherReceiptListPrintComponent } from './voucher-receipt-list-print/voucher-receipt-list-print.component';
import { OpeningBalancePostComponent } from './opening-balance-post/opening-balance-post.component';
const routes: Routes = [
  { 
    path: '', 
    component: AdminComponent,
    children: [
      { path: 'openingbalancepost', component:OpeningBalancePostComponent, pathMatch: 'full'},
      { path: 'voucherpayment', component:VoucherPaymentComponent, pathMatch: 'full'},
      { path: 'voucherreceipt', component:VoucherReceiptComponent, pathMatch: 'full'},
      { path: 'accsetting', component:AccSettingComponent, pathMatch: 'full'},
      { path: 'bankaccount', component:BankAccountComponent, pathMatch: 'full'},
      { path: 'vendor', component:VendorComponent, pathMatch: 'full'},
      { path: 'bank', component:BankComponent, pathMatch: 'full'},
      { path: 'accaccount', component:AccAccountComponent, pathMatch: 'full'},
      { path: 'bankpayment', component:BankPaymentComponent, pathMatch: 'full'},
      { path: 'bankreceipt', component:BankReceiptComponent, pathMatch: 'full'},
      { path: 'cashreceipt', component:CashReceiptComponent, pathMatch: 'full'},
      { path: 'cashpayment', component:CashPaymentComponent, pathMatch: 'full'},
      { path: 'journal', component:JournalComponent, pathMatch: 'full'},
      { path: 'journalreport', component:JournalReportComponent, pathMatch: 'full'},
      { path: 'balancesheetreport', component:BalancesheetReportComponent, pathMatch: 'full'},
      { path: 'trialbalancereport', component:TrialbalanceReportComponent, pathMatch: 'full'},
      { path: 'profitlossreport', component:ProfitLossReportComponent, pathMatch: 'full'},
      { path: 'voucherreport', component:VoucherReportComponent, pathMatch: 'full'},
      { path: 'ledger', component:LedgerComponent, pathMatch: 'full'},
      { path: 'feedailyclosing', component:FeeDailyClosingComponent, pathMatch: 'full'},
      { path: 'postfeedaily', component:PostFeeDailyComponent, pathMatch: 'full'},
      { path: 'postmodernexchangefeedaily', component:PostModernExchangeFeeDailyComponent, pathMatch: 'full'},
      
    ]
},
{ 
  path: '',   
  children: [
    { path: 'voucherreceiptprint', component:VoucherReceiptPrintComponent, pathMatch: 'full'},
    { path: 'voucherreceiptlistprint', component:VoucherReceiptListPrintComponent, pathMatch: 'full'},
    { path: 'voucherpaymentprint', component:VoucherPaymentPrintComponent, pathMatch: 'full'},
    { path: 'voucherpaymentlistprint', component:VoucherPaymentListPrintComponent, pathMatch: 'full'},
    { path: 'bankpaymentprint', component:BankPaymentPrintComponent, pathMatch: 'full'},
    { path: 'voucherreportprint', component:VoucherReportPrintComponent, pathMatch: 'full'},
    { path: 'journalvoucherprint', component:JournalVoucherPrintComponent, pathMatch: 'full'},
    { path: 'profitlossreportprint', component:ProfitLossReportPrintComponent, pathMatch: 'full'},
    { path: 'trialbalancereportprint', component:TrialbalanceReportPrintComponent, pathMatch: 'full'},
    { path: 'balancesheetreportprint', component:BalancesheetReportPrintComponent, pathMatch: 'full'},
    { path: 'journalreportprint', component:JournalReportPrintComponent, pathMatch: 'full'},
    { path: 'ledgerprint', component:LedgerPrintComponent, pathMatch: 'full'},
    { path: 'bankpaymentvoucherprint', component:BankPaymentVoucherPrintComponent, pathMatch: 'full'},
    { path: 'bankreceiptprint', component:BankReceiptPrintComponent, pathMatch: 'full'},
    { path: 'bankreceiptvoucherprint', component:BankReceiptVoucherPrintComponent, pathMatch: 'full'},
    { path: 'cashpaymentprint', component:CashPaymentPrintComponent, pathMatch: 'full'},
    { path: 'cashpaymentvoucherprint', component:CashPaymentVoucherPrintComponent, pathMatch: 'full'},
    { path: 'cashreceiptvoucherprint', component:CashReceiptVoucherPrintComponent, pathMatch: 'full'},
    { path: 'cashreceiptprint', component:CashReceiptPrintComponent, pathMatch: 'full'},
  ]
}






];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountingRoutingModule { }
